<!--
<button mat-button [routerLink]="'/keep'">
    Accueil 
</button>

<button mat-button [routerLink]="'/keep/appointment'">
    Prendre rendez vous
</button>  -->
<!-- 
<button mat-button [routerLink]="'/keep/warranty'">
    Garantie
</button>

<button mat-button [routerLink]="'/keep/routine'">
    Routine 
</button>

<button mat-button [routerLink]="'/keep/repair'">
    Réparer 
</button>

<button mat-button [routerLink]="'/keep/control'">
    Controle technique 
</button> -->

<!-- <button mat-button [routerLink]="'/provider/search'">
    Trouver provider
</button> -->

<router-outlet></router-outlet>